import { useAlert } from 'contexts/alertContext';
import { getCompanyJobs } from 'framework/companyjobs';
import { getCountries } from 'framework/countries';
import { handleError, isValidEmail } from 'helpers/utils';
import { ICompanyJob } from 'models/companyJob';
import { ICountry } from 'models/country';
import { IEmployeeInput } from 'models/employee';
import React, { useCallback, useEffect, useState } from 'react'
import { QueryClient, useMutation } from 'react-query';
import RegisterForm from './partials/RegisterForm';
import { ICompanyDepartments } from 'models/companyDepartment';
import phone from 'phone';
import { addEmployee, createUser } from 'framework/employee';
import useApp from 'hooks/useApp';
import { Box, Button, Paper, Skeleton, Stack, Typography } from '@mui/material';
import MuiSnackbar from 'components/UI/MuiSnackbar';
import { useParams } from 'react-router-dom';
import { getCompanyDepartments } from 'framework/companyDepartments';
import MuiButton from 'components/UI/MuiButton';


function isValidNumber(countryCodeNumeric: string): boolean {
  const { isValid } = phone(countryCodeNumeric);
  return isValid;

}

function Register() {
        const { push } = useApp();
        const {id} = useParams()
        const { alert, setAlert } = useAlert();
        const queryClient = new QueryClient();
        const [loading, setLoading] = useState<boolean>(true);
        const [loading2, setLoading2] = useState<boolean>(false);
        const [Countries, setCountries] = useState<ICountry[]>([] as ICountry[]);
        const [CompanyJobs, setJobs] = useState<ICompanyJob[]>([] as ICompanyJob[]);
        const [CompanyDepartments, setCompanyDepartments] = useState<ICompanyDepartments[]>([] as ICompanyDepartments[]);
        const [inputObj, setInputObj] = useState<IEmployeeInput>({} as IEmployeeInput);

          const addEmployeesMutation = useMutation({
            mutationFn: (createInput: FormData) => {
              return createUser(`?companyId=${id}`,createInput);
            },
          });

      const handleChange = (name: string, value: any) => {
        setInputObj((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

        const fetchCountries = useCallback(async () => {
            setLoading(true)
            try {
              let response: any = await queryClient.fetchQuery("get Countries", () =>
                getCountries()
              );
              setCountries(response);
            } catch (error: any) {
              setAlert({
                open: true,
                message: handleError(error) || "Something went wrong",
                type: "error",
              });
            }
            finally {setLoading(false)}
        
            // eslint-disable-next-line
          }, [queryClient, setAlert]);
    
        const fetchCompanyJobs = useCallback(async () => {
            setLoading(true)  
            try {
                let response: any = await queryClient.fetchQuery("get Jobs", () =>
                  getCompanyJobs('?companyId='+id)
                );
                 setJobs(response);
              } catch (error: any) {
                setAlert({
                  open: true,
                  message: handleError(error) || "Something went wrong",
                  type: "error",
                });
            }
            finally {setLoading(false)}
          
              // eslint-disable-next-line
            }, [queryClient, setAlert]);


            const fetchCompanyDepartments = useCallback(async () => {
                setLoading(true)
                try {
                  let response: any = await queryClient.fetchQuery(
                    "get Company Departments",
                    () => getCompanyDepartments('?companyId='+id)
                  );
                  setCompanyDepartments(response);
                } catch (error: any) {
                  setAlert({
                    open: true,
                    message: handleError(error) || "Something went wrong",
                    type: "error",
                  });
                } finally {setLoading(false)}
            
                // eslint-disable-next-line
              }, [queryClient, setAlert]);

    useEffect(() => {
        fetchCountries();
        fetchCompanyJobs();
        fetchCompanyDepartments()
        // eslint-disable-next-line
      }, []);

if (loading)
    return (
      <Stack spacing={2} p={2}>
        {Array.from({ length: 10 }).map((_, i) => (
          <Skeleton variant="rectangular" key={i} width="100%" height={30} />
        ))}
      </Stack>
    );
         const handleAdd = async () => {
            if (
              !inputObj.FirstName ||
              !inputObj.MiddleName ||
              !inputObj.LastName ||
              !inputObj.CountryCode ||
              !inputObj.PhoneNumber ||
              !inputObj.Email ||
              !inputObj.ResidenceCountryId ||
              !inputObj.CompanyDepartmentId ||
              !inputObj.CompanyJobId
        
            )
              return setAlert({
                open: true,
                message: "Please fill all required fields",
                type: "error",
              });
        
            if (
              !isValidEmail(inputObj.Email)
        
            )
              return setAlert({
                open: true,
                message: "Please Enter Valid Email",
                type: "error",
              });
        
            if (
              !isValidNumber(inputObj.CountryCode + inputObj.PhoneNumber))
        
        
              return setAlert({
                open: true,
                message: "This Phone is not valid in this country",
                type: "error",
              });
            try {
              setLoading2(true);
              const createInput = new FormData();
              if (inputObj.EmployeeId) createInput.append("EmployeeId", inputObj.EmployeeId);
              if (inputObj.FirstName) createInput.append("FirstName", inputObj.FirstName);
              if (inputObj.MiddleName) createInput.append("MiddleName", inputObj.MiddleName);
              if (inputObj.LastName) createInput.append("LastName", inputObj.LastName);
              if (inputObj.FirstNameAr) createInput.append("FirstNameAr", inputObj.FirstNameAr);
              if (inputObj.MiddleNameAr) createInput.append("MiddleNameAr", inputObj.MiddleNameAr);
              if (inputObj.LastNameAr) createInput.append("LastNameAr", inputObj.LastNameAr);
              if (inputObj.CountryCode) createInput.append("CountryCode", inputObj.CountryCode);
              if (inputObj.Email) createInput.append("Email", inputObj.Email);
              if (inputObj.CompanyJobId) createInput.append("CompanyJobId", inputObj.CompanyJobId);
              if (inputObj.ResidenceCountryId) createInput.append("ResidenceCountryId", inputObj.ResidenceCountryId);
              if (inputObj.PhoneNumber) createInput.append("PhoneNumber", inputObj.PhoneNumber);

              if (inputObj.ProfilePicture)
                createInput.append("ProfilePicture", inputObj.ProfilePicture || inputObj.ProfilePicture?.[0]);
              await addEmployeesMutation.mutateAsync(createInput);
              setAlert({
                open: true,
                message: "Successfully Created User",
                type: "success",
              });
              setLoading2(false);
              
              // Check for enrollment redirect
              const enrollmentRedirect = localStorage.getItem("enrollmentRedirect");
              if (enrollmentRedirect) {
                // Don't remove it yet - Login page will handle that
                push("/login");
              } else {
                push("/login");
              }
            } catch (error: any) {
              setAlert({
                open: true,
                message: handleError(error) || "Something went wrong",
                type: "error",
              });
              setLoading2(false);
            }
          };

  return (
  <Paper elevation={3} sx={{ p: 4,  }}>
      <Typography variant="h5" component="h2" gutterBottom>
        Register New Employee
      </Typography>

      <RegisterForm
        Countries={Countries}
        CompanyJobs={CompanyJobs}
        CompanyDepartments={CompanyDepartments}
        onChanges={handleChange}
      />

      <Box mt={3} textAlign="right">
        <MuiButton
          onClick={handleAdd}
          disabled={loading}
          variant="contained"
          color="primary"
        >
          Submit
        </MuiButton>
      </Box>
       <MuiSnackbar alert={alert!} />
    </Paper>
  )
}

export default Register
